import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import { useSettings } from '../contexts/SettingsContext';

const LogoTest: React.FC = () => {
  const { settings, loading } = useSettings();
  const [imageStatus, setImageStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorDetails, setErrorDetails] = useState<string>('');

  useEffect(() => {
    if (!loading && settings.general.logoUrl) {
      console.log('Testing logo URL:', settings.general.logoUrl);
      
      const img = new Image();
      img.onload = () => {
        console.log('Logo image loaded successfully in test component');
        setImageStatus('success');
      };
      img.onerror = (e) => {
        console.error('Error loading logo image in test component:', e);
        setImageStatus('error');
        setErrorDetails(JSON.stringify(e));
      };
      img.src = settings.general.logoUrl;
    }
  }, [settings, loading]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Paper sx={{ p: 3, m: 3 }}>
      <Typography variant="h5" gutterBottom>Logo Test Component</Typography>
      
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1">Logo URL from settings:</Typography>
        <Typography variant="body2" component="pre" sx={{ 
          p: 1, 
          bgcolor: 'background.paper', 
          borderRadius: 1,
          overflowX: 'auto'
        }}>
          {settings.general.logoUrl || 'No logo URL found in settings'}
        </Typography>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1">Image Status: {imageStatus}</Typography>
        {imageStatus === 'error' && (
          <Typography variant="body2" color="error" component="pre" sx={{ 
            p: 1, 
            bgcolor: 'background.paper', 
            borderRadius: 1,
            overflowX: 'auto'
          }}>
            {errorDetails || 'Unknown error'}
          </Typography>
        )}
      </Box>
      
      {settings.general.logoUrl && (
        <Box>
          <Typography variant="subtitle1">Image Preview:</Typography>
          <Box 
            component="img"
            src={settings.general.logoUrl}
            alt="Logo Preview"
            sx={{ 
              maxWidth: '100%', 
              height: 'auto',
              maxHeight: 100,
              display: 'block',
              border: '1px solid',
              borderColor: 'divider',
              p: 1
            }}
            onError={() => console.log('Image failed to load in JSX element')}
          />
        </Box>
      )}
    </Paper>
  );
};

export default LogoTest; 